module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMP///+20ulgns7z+PuFtdqx66FmAAAACHRSTlMAYL//ACDP71kzCuAAAADkSURBVHja7dixEcMwDENRyZDk0OH+88au0AWXA9PpD/B6oD31A0ZHH3dtjLlgtuYDzRN257yhhYLWaB0l9XagpKOhqA1taEO/Qq/vhQnR8SE6PhTwITo+FPAhOj4U8CE6PhQogq4q6H25ECUXouRClFyIkgtRciFKLkTJhSi5ECUDEpKC4nprCRoKQEgCoiMkBdERkoLoCElBdJSkoQC0pKHH0VJqKAAtJSQUgJYSGgK0lBCQlOhoSEsJA6JER0BKSjgQpYQDUUo4EKXcE2JD/4TKTpay26fqiCq7xirPuruK+/AD9Q1RNhzOHhsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2196.png
// module id = 1318
// module chunks = 0